import { request } from "../base";

export type RoomCategoryMedia = {
	id: number;
	url: string;
	altText: string | null;
	proName: string;
	proBusinessName: string;
	projectTitle: string;
	projectId: string;
	uploadedAt: string;
	viewCount: number;
};

export type RoomCategoryWithStats = {
	code: string;
	label: string;
	sortOrder: number;
	coverMediaId: number | null;
	coverMediaUrl: string | null;
	coverMediaAlt: string | null;
	coverProjectTitle: string | null;
	coverProName: string | null;
	coverUploadedAt: string | null;
	coverSource: "curated" | "algorithmic" | "empty";
	projectCount: number;
	photoCount: number;
};

export const adminRoomCategoriesApi = {
	async listRoomCategoriesWithStats() {
		return request<RoomCategoryWithStats[]>(
			`/api/admin/taxonomy/roomTypes/list-with-stats`,
		);
	},

	async getRoomCategory(code: string) {
		return request<RoomCategoryWithStats>(
			`/api/admin/taxonomy/roomTypes/${code}/with-stats`,
		);
	},

	async listMediaForRoomType(
		code: string,
		opts: { limit?: number; sortBy?: "recent" | "popular" } = {},
	) {
		const params = new URLSearchParams({
			limit: String(opts.limit ?? 100),
			sortBy: opts.sortBy ?? "recent",
		});
		return request<RoomCategoryMedia[]>(
			`/api/admin/taxonomy/roomTypes/${code}/media?${params}`,
		);
	},

	async setRoomCategoryCover(code: string, mediaId: number) {
		return request<RoomCategoryWithStats>(
			`/api/admin/taxonomy/roomTypes/${code}/cover`,
			{
				method: "PUT",
				body: { coverMediaId: mediaId },
			},
		);
	},

	async clearRoomCategoryCover(code: string) {
		return request<RoomCategoryWithStats>(
			`/api/admin/taxonomy/roomTypes/${code}/cover`,
			{
				method: "PUT",
				body: { coverMediaId: null },
			},
		);
	},
};
